import { useCallback, useEffect, useMemo } from "react";

import StatCard from "../../components/stats/StatCard";
import StatLoader from "./StatLoader";

import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { getTourStats } from "../../store/stats/stats-slice";

interface ToursProps {
  propertyID: string;
}

const defaultData = {
  title: "Tours",
  barData: {
    value: 0,
    total: 0,
    goal: 0,
  },
  topData: {
    label: "YTD Tour Goal",
    value: 0,
  },
  bottomData: {
    label: "YTD Variance",
    value: 0,
  },
};

const Tours = ({ propertyID }: ToursProps): ReactNode => {
  const dispatch = useAppDispatch();
  const tours: any = useAppSelector((state) => state.stats.tours);
  console.log("🔍 Tours prop propertyID:", propertyID);
  console.log("Tours API data:", tours.data);
  console.log("Selected propertyID:", propertyID);
  const selectedPropertyData = useMemo(() => {
    if (tours.data.length === 0 || tours.isLoading) {
      return defaultData;
    }

    if (!propertyID && !tours.isLoading && tours.data.length > 0) {
      return defaultData;
    }

    const selectedData = tours.data.find(
      (property: any) => property.PropertyID === propertyID
    );

    if (!selectedData) {
      return defaultData;
    }

    return {
      title: "Tours",
      barData: {
        value: selectedData.ytd_actual ?? 0,
        total: selectedData.annual_goal ?? 0,
        goal: selectedData.ytd_tour_goal ?? 0,
      },
      topData: {
        label: "YTD Goal",
        value: selectedData.ytd_tour_goal ?? 0,
      },
      bottomData: {
        label: "YTD Variance",
        value: selectedData.ytd_variance ?? 0,
      },
    };
  }, [propertyID, tours]);

  const fetchData = useCallback(async () => {
    try {
      if (!propertyID) {
        return;
      }

      await dispatch(getTourStats(propertyID));
    } catch (error) {
      console.log("error:", error);
    }
  }, [dispatch, propertyID]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <StatLoader isLoading={tours.isLoading} />
      <StatCard
        data={selectedPropertyData ? selectedPropertyData : defaultData}
      />
    </>
  );
};

export default Tours;
